import { Box } from "@material-ui/core";
import { Tooltip, Typography } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import DataTableLatest from "../../components/DataTable/DataTableLatest";
import UpdateDeviceType from "../../components/DialogBoxComponent/UpdateDeviceType";
import Toast from "../../components/ToastContainer/CustomToast";
import EditIcon from "../../Pages/Person/EditIcon";
import {
  downloadAPKFileById,
  getDeviceTypeList,
} from "../../slices/DeviceTypeSlice/DeviceTypeSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import CommonUtil from "../../Util/CommonUtils";
import SimpleDialogDemo from "../Approvals/ImageDailogBox";
import DownloadInvoiceIcon from "../Customer/DownloadInvoiceIcon";

function DeviceTypeLists() {
  const { t } = useTranslation();
  const [clear, setClear] = React.useState(false);
  const [rows, setRows] = useState([]);
  const [page, setPage] = useState(1);
  const dispatch = useDispatch();
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(1);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(0);
  const [openUpdateDialog, setOpenUpdateDialog] = useState(false);
  const [data, setData] = useState({});
  const { setDiaLogBoxBlur } = useContext(ThemeContext);
  const companySettings = JSON.parse(localStorage.getItem("companySettings"));

  const handleChange = (newPage, size) => {
    setPage(newPage);
    setPaging({
      pageNumber: newPage,
      pageSize: size,
    });
  };

  const [filter, setfilter] = useState({});

  const [paging, setPaging] = useState({
    pageNumber: 1,
    pageSize: 50,
  });

  useEffect(() => {
    loadData(filter, paging);
  }, [filter, paging]);

  const loadData = (filter, paging) => {
    dispatch(getDeviceTypeList(Object.assign(filter, paging)))
      .unwrap()
      .then((data) => {
        if (data.code === "MSGS4000") {
          setLoading(false);
          setTotalRecords(data.data.totalCount);
          setRows(data.data.deviceType);
          setPage(data.data.currentPage);
          setTotalPages(data.data.totalPages);
          setPageSize(data.data.pageSize);
        } else {
          setRows([]);
        }
      })
      .catch((er) => {});
  };

  const handleTextOverflow = (text) => {
    if (text && text.length > 15) {
      return text.substring(0, 20) + "...";
    } else {
      return text;
    }
  };

  const formatDate = (dateFormat) => {
    switch (dateFormat) {
      case "DD-MM-YYYY":
        return "dd-MM-yyyy HH:mm";
      case "MM-DD-YYYY":
        return "MM-dd-yyyy HH:mm";
      case "YYYY-MM-DD":
        return "yyyy-MM-dd HH:mm";
      default:
        return "yyyy-MM-dd HH:mm";
    }
  };
  const renderCellReleaseDate = (date) => (params) => {
    const formattedDate = moment(
      CommonUtil.getLocalDateTimeInYearFormat(params.row.updatedAt)
    ).format(
      date === "dd-MM-yyyy HH:mm"
        ? "DD-MM-YYYY HH:mm"
        : date === "MM-dd-yyyy HH:mm"
        ? "MM-DD-YYYY HH:mm"
        : "YYYY-MM-DD HH:mm"
    );

    return <span className="table-cell-trucate">{formattedDate}</span>;
  };

  const handleDownloadAPKFile = (params) => {
    const payload = {
      id: params.id,
      deviceModel: params.deviceModel,
      fileName: params.fileName,
    };
    dispatch(downloadAPKFileById(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "CVSI0000") {
          if (params.objectKey === data.data.objectKey) {
            window.open(data.data.preSignedUrl);
            Toast(t("APK File Download Success"), "success");
          }
        } else if (data.code === "STSE0018") {
          Toast(t("APK File Not Upload"), "error");
        }
      });
  };

  const ZoomHandaler = (params) => <SimpleDialogDemo />;
  const columns = React.useMemo(
    () => [
      {
        field: "company.profile",
        headerName: "",
        sortable: false,
        width: 10,
        renderCell: (params) => {
          return ZoomHandaler(params);
        },
      },
      {
        field: "DeviceMode1",
        headerName: t("DEVICE_TYPE_MODEL"),
        flex: 1,
        minWidth: 120,
        valueGetter: (params) => params.row.deviceModel,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "androidVersion",
        headerName: t("DEVICE_TYPE_VERSION"),
        flex: 1,
        minWidth: 170,
        valueGetter: (params) => params.row.androidVersion,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "currentApplication",
        headerName: t("DEVICE_TYPE_APPLICATION"),
        flex: 1,
        minWidth: 220,
        valueGetter: (params) =>
          params.row.majorVersion +
          "." +
          params.row.minorVersion +
          "." +
          params.row.patchVersion,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "fileName",
        headerName: t("DEVICE_FILE_NAME"),
        flex: 1,
        minWidth: 250,
        valueGetter: (params) => params.row.fileName,
        renderCell: (params) => (
          <Tooltip title={`${params.value}`} placement="bottom-start">
            <span>{handleTextOverflow(params.value)}</span>
          </Tooltip>
        ),
      },

      {
        field: "ReleaseDate",
        headerName: t("DEVICE_RELEASE_DATE"),
        flex: 1,
        minWidth: 140,
        renderCell: renderCellReleaseDate(
          formatDate(companySettings?.adminAndDealerDateFormat)
        ),
      },

      {
        field: "Actions",
        headerName: t("ACTION"),
        type: "actions",
        flex: 1,
        minWidth: 190,
        width: 150,
        headerAlign: "center",
        getActions: (params) => [
          <GridActionsCellItem
            icon={<EditIcon />}
            label={t("COMMON052")}
            onClick={() => {
              setOpenUpdateDialog(!openUpdateDialog);
              setDiaLogBoxBlur(true);
              handleUpdateDeviceType(params.row);
            }}
          />,
          <GridActionsCellItem
            icon={<DownloadInvoiceIcon />}
            label={t("APK FILE")}
            onClick={() => handleDownloadAPKFile(params.row)}
          />,
        ],
      },
    ],
    []
  );

  const handleUpdateDeviceType = (data) => {
    setData(data);
  };

  const updateDeviceType = () => {};

  return (
    <>
      <Typography variant="h3">{t("DEVICE_TYPE_HEADER")}</Typography>

      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row"}
        justifyContent={"flex-end"}
        alignItems={"center"}
        gap="5px"
        style={{
          padding: "10px 0px 10px 10px",
        }}
      ></Box>

      <div style={{ height: 300, width: "100%", paddingTop: "20px" }}>
        <DataTableLatest
          columns={columns}
          rows={rows}
          page={page}
          // approvals={true}
          count={totalRecords}
          rowId={(row) => row.id}
          pageCount={totalPages}
          pageSize={rowsPerPage}
          handleChange={(newPage, size) => handleChange(newPage, size)}
        />
      </div>
      {openUpdateDialog && (
        <UpdateDeviceType
          onClose={() => {
            setOpenUpdateDialog(!openUpdateDialog);
            loadData(filter, paging);
            setDiaLogBoxBlur(false);
          }}
          onSubmit={updateDeviceType}
          open={openUpdateDialog}
          data={data}
        />
      )}
    </>
  );
}
export default DeviceTypeLists;
